import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

// bundle the default language
import en from '../../../translations/en/locale_1.json';

const ORG_LOCALE = wbConfig.default_org_locale;
const LANGUAGE = wbConfig.userLocale;

const isI18nDebug = () =>
  typeof document !== 'undefined' && /(^|;\s*)wb_i18n_debug=1/.test(document.cookie);

i18n
  .use({
    type: 'postProcessor',
    name: 'wbMissingKeyMarker',
    process: (value, key, options, translator) => {
      const lng = translator?.language || i18n.language;
      if (!isI18nDebug() || !lng || lng === 'en' || lng === 'en-us') return value;
      const k = Array.isArray(key) ? key[0] : key;
      return i18n.exists(k, { lng }) ? value : `[[${value}]]`;
    },
  })
  .use(resourcesToBackend((language, namespace, callback) =>
    // don't bundle other languages - load them on demand
    import(`../../../translations/${LANGUAGE}/${ORG_LOCALE}.json`)
      .then((resources) => {
        callback(null, resources?.[namespace]);
      })
      .catch((error) => {
        callback(error, null);
      })))
  // .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: LANGUAGE === 'en' && ORG_LOCALE === 'locale_1' ? en : undefined },
    partialBundledLanguages: true,
    /* default language when load the website in browser */
    lng: wbConfig.userLocale,
    /* When react i18next not finding any language to as default in browser */
    fallbackLng: 'en',
    /* debugger For Development environment */
    debug: true,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    postProcess: ['wbMissingKeyMarker'],
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    }
  });

// Make i18n globally available for legacy JavaScript files
if (typeof window !== 'undefined') {
  window.i18n = i18n;
}

export default i18n;
